// extracted by mini-css-extract-plugin
export default {"resetPasswordButton":"ResetPassword_resetPasswordButton__QCCsH","resetPasswordSecondaryButton":"ResetPassword_resetPasswordSecondaryButton__n-5VW"};